export function payment(state = [], action) {

  switch (action.type) {
    case "VERIFY_PAYMENT":
      return state;
    case "VERIFY_PAYMENT_COMPLETE":
      return { ...state, ...action.payload };
    case "VERIFY_PAYMENT_ERROR":
      return state;
    case "REMOVE_PAYMENT_ERROR":
      return { ...state, PaymentError: null };
    case "SUBMIT_PAYMENT":
      return state;
    case "SUBMIT_PAYMENT_COMPLETE":
      // Preserve the feeType from the previous state
      return { ...action.payload, feeType: state.feeType };
    case "SET_APPRAISAL_CHARGE_FEE":
      return { ...state, appraisalFee: action.fee };
    case "SET_FEE_TYPE":
      return { ...state, feeType: action.feeType };
    case "GET_POST_DATE":
      // set PaymentError to an empty string so the error handling
      // and navigation works between the payment entry and review pages
      return { ...action.payload, PaymentError: "" };
    case "CLEAR_PAYMENT":
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/payment.js